/* Zunft-Werkstatt, Produktseite: übernimmt Gewerk, Titel und Name aus dem Link der Werkstatt-Karten (?gewerk=&oben=&unten=, sm-coll-zunft.js)
   in Zeptos Felder, sobald der Personalisierer sie aufbaut (Fenster nach „Jetzt Personalisieren“ oder Felder direkt auf der Seite).
   Gewerk: in der Auswahl „Deine Zunft“, „Zunftzeichen“, „Zunftzeichen Auswahl“, „Wähle Deine Zunft“ oder „Beruf“ das Motiv des Gewerks. Zeptos Optionsnamen
   weichen je Produkt ab (Bergman, Dachdeker, Brauer und Malzer), deshalb der Name je Produkt aus assets/sm-zunft-wahl.json (tools/daten.py).
   Nie in Auswahlen mit Aufpreis (passender Anhänger, Zippo, Anstecker): Zepto rechnet dort den Aufpreis, das wählt nur der Besucher.
   Titel in „Oberer Text“, „Meister oder Wunschtext“, „Text oben“, „Titel“, „Berufsbezeichnung“; ohne eigenen Titel der übliche des Gewerks wie auf der Karte.
   Name in „Unterer Text“, „Name oder Datum“, „Name oder Datum unten“, „Name“, „Name oder Wunschtext“. Rückseiten und alle anderen Felder bleiben unberührt.
   Eingetragen wird nur, was hineinpasst (Grenze in data-maxlength); Zeptos Beispielwerte (Kartenhalter: „Zimmerermeister“) werden ersetzt. Was der Besucher selbst ändert oder wählt, bleibt so,
   auch wenn Zepto seinen Block neu aufbaut. Zeptos Zeichenzähler: jedes Feld danach der Reihe nach zweimal input und keyup, 700 ms Abstand
   (ein Aufruf für das nächste Feld bricht Zeptos verzögertes Zählen ab, wie in sm-schild-pdp.js).
   Am script-Tag (layout/theme.liquid, nur Produkte der Kollektion zunftzeichen): data-handle (Produkt), data-src (sm-zunft-wahl.json). */
(function(){
  const me = document.currentScript, q = new URLSearchParams(location.search), gw = q.get('gewerk') || '';
  if (!me || !gw) return;
  const kurz = t => (t || '').replace(/\s+/g, ' ').trim().slice(0, 40);
  const handle = me.dataset.handle, uOben = kurz(q.get('oben')), unten = kurz(q.get('unten'));
  const WAHL = /^(deine zunft|zunftzeichen|zunftzeichen auswahl|wähle deine zunft|beruf)$/, OBEN = /^(oberer text|meister oder wunschtext|text oben|titel|berufsbezeichnung)$/,
    UNTEN = /^(unterer text|name oder datum|name oder datum unten|name|name oder wunschtext)$/;
  const BEN = {}, MAL = {};   // BEN: Felder (nach Namen), die der Besucher selbst angefasst hat; am Namen, weil Zepto seine Felder neu aufbaut.
                             // MAL: wie oft das Skript ein Feld gesetzt hat; höchstens 5, falls Zepto einen Wert immer wieder verwirft (sonst Endlosschleife mit dem Beobachter)
  const darf = n => (MAL[n] = (MAL[n] || 0) + 1) <= 5;
  let W = null, oben = uOben;
  document.addEventListener('input', e => { const t = e.target; if (e.isTrusted && t && t.name && t.classList.contains('pplr_text')) BEN[t.name] = 1; }, true);
  document.addEventListener('click', e => { const s = e.isTrusted && e.target.closest && e.target.closest('.pplr-swatch-element'); if (s) BEN[s.getAttribute('name')] = 1; }, true);
  function etikett(w){
    const lb = w.querySelector('.pplrlabel'); if (!lb) return '';
    const c = lb.cloneNode(true); c.querySelectorAll('.ptooltip, .pplr_option_price_span').forEach(e => e.remove());
    return c.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
  }
  const zeichen = t => Array.from(t).length;
  function setzen(el, v){
    const proto = el.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
    Object.getOwnPropertyDescriptor(proto, 'value').set.call(el, v);
    el.dispatchEvent(new Event('input', { bubbles: true })); el.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true })); el.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function waehlen(w){
    const inp = w.querySelector('input.pplr_imgg'), name = W.wahl[handle] && W.wahl[handle][gw];
    if (!inp || !name || BEN[inp.name] || inp.classList.contains('pplraddprice') || inp.value === name) return;
    const sw = Array.from(w.querySelectorAll('.pplr-swatch-element')).find(s => s.dataset.val === name);
    if (!sw || +(sw.dataset.pplr_price || 0) > 0 || !darf(inp.name)) return;
    const liste = sw.closest('.pplrgcolor'), zu = liste && getComputedStyle(liste).display === 'none';
    sw.click();
    if (zu) liste.style.display = 'none';   // chooseimage klappt die Liste auf; sie bleibt zu wie vorher
  }
  let zq = [], zt = 0;
  function naechst(){
    const el = zq.shift(); zt = 0; if (!el) return;
    if (el.isConnected && !BEN[el.name]){ el.dispatchEvent(new Event('input', { bubbles: true })); el.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true })); }
    if (zq.length) zt = setTimeout(naechst, 700);
  }
  function fuellen(){
    const neu = [];
    document.querySelectorAll('.pplr-wrapper').forEach(w => {
      const l = etikett(w);
      if (WAHL.test(l)){ waehlen(w); return; }
      const el = w.querySelector('input.pplr_text, textarea.pplr_text'); if (!el || !el.name || BEN[el.name]) return;
      const v = OBEN.test(l) ? oben : UNTEN.test(l) ? unten : ''; if (!v || el.value === v) return;
      const max = parseInt(el.getAttribute('data-maxlength'), 10) || el.maxLength;
      if (max > 0 && zeichen(v) > max || !darf(el.name)) return;
      setzen(el, v); neu.push(el);
    });
    if (neu.length) zq = zq.filter(el => neu.indexOf(el) < 0).concat(neu, neu);   // zwei Durchgänge: ein späterer Aufruf von Zepto bricht das Zählen sonst manchmal ab
    if (zq.length && !zt) zt = setTimeout(naechst, 700);
  }
  fetch(me.dataset.src).then(r => r.json()).then(d => {
    W = d; if (!oben) oben = d.oben[gw] || '';
    let tm = 0;
    new MutationObserver(() => { clearTimeout(tm); tm = setTimeout(fuellen, 150); }).observe(document.body, { childList: true, subtree: true });
    fuellen();
  }).catch(() => {});
})();
